export default Symbol('protected');